import { atom } from "recoil";

// 글로벌 로딩 카운트 (동시 요청 대비)
export const globalLoadingCountState = atom({
  key: "globalLoadingCountState",
  default: 0,
});
